<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import MainNavigatBar from './views/components/MainNavigatBar/MainNavigatBar'
  import BottomBar from './views/components/BottomBar/BottomBar'
  export default {
    name: 'App',
    components: {
      MainNavigatBar,
      BottomBar
    }
  }
</script>
<style lang="less">
  @import "~@/styles/app.less";

  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  #app {
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    position: relative;

    /* 隐藏滚动条但保持可以滚动 - Webkit浏览器 */
    &::-webkit-scrollbar {
      display: none;
    }

    /* 隐藏滚动条但保持可以滚动 - Firefox */
    scrollbar-width: none;

    /* 隐藏滚动条但保持可以滚动 - IE */
    -ms-overflow-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue